interface GetConnectionTaskTitleParams {
    detectedInstitutionName: string | null;
}

/**
 * Single source of truth for the title of the connection task created at
 * accounts-mapping finalization. The mapping drawer previews the same title
 * before the task exists, so both sides must derive it identically.
 */
export function getImportedAccountConnectionTaskTitle({
    detectedInstitutionName,
}: GetConnectionTaskTitleParams): string {
    return detectedInstitutionName
        ? `Connect ${detectedInstitutionName}`
        : "Connect other accounts";
}
